export default [
    "2/4",
    "3/4",
    "4/4",
    "5/4",
    "7/4",
    "6/8"
]